import { Component, OnInit, Inject } from '@angular/core';
import { VersionService } from 'src/app/services/version.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-version-otp',
  templateUrl: './version-otp.component.html',
  styleUrls: ['./version-otp.component.css']
})
export class VersionOtpComponent {
  api_success: string;
  api_error: any;
  versionFormVal: any;
  disableConfirmbtn = false;
  constructor(private versionService: VersionService, @Inject(MAT_DIALOG_DATA) public data: any, private dialog: MatDialogRef<any>) {
    this.versionFormVal = this.data;
  }
  otp = undefined;
  showOtpComponent = true;

  config = {
    allowNumbersOnly: false,
    length: 4,
    inputStyles: {
      'width': '40px',
      'height': '50px'
    }
  };

  // constructor() { }

  // ngOnInit() {
  // }
  onOtpChange(otp) {
    this.otp = otp;
  }

  otpSubmit() {
    this.api_success = '';
    this.api_error = '';
    if (this.otp === '' || this.otp === undefined) {
      this.api_error = 'Invalid OTP';
    } else {
      this.disableConfirmbtn = true;
      this.versionService.verifyOtp(this.otp)
        .subscribe(res => {
          this.disableConfirmbtn = false;
          this.api_success = 'version updated successfully';
          setTimeout(() => {
            this.dialog.close();
          }, 2000);
        },
          (error) => {
            this.disableConfirmbtn = false;
            this.api_error = error.error;
          });
    }
  }
  resendOtp() {
    this.api_error = '';
    this.api_success = '';
    this.versionService.updateVersion(this.data)
      .subscribe(res => {
        this.api_success = 'OTP has been send to email successfully,Please contact Superadmin';
      },
        (error) => {
          this.api_error = error.error;

        });
  }

  onConfigChange() {
    this.showOtpComponent = false;
    setTimeout(() => {
      this.showOtpComponent = true;
    }, 0);
  }

}
